import { Component } from '@angular/core';
import { DialpadService } from '../../services/dialpad.service';
import { CampaignService } from '../../services/campaign.service';

@Component({
  selector: 'app-verbiage',
  templateUrl: './verbiage-updated.component.html',
})
export class VerbiageComponent {
  openWrapText = false;
  isTCPAOpen = false;
  constructor(public dialpadService: DialpadService, public campaignService: CampaignService) {}

  public toggleText() {
    this.openWrapText = !this.openWrapText;
  }
  public toggleTCPA() {
    this.isTCPAOpen = !this.isTCPAOpen;
  }
}
